/**
 * localStorage that cannot take the page down.
 *
 * Private-mode Safari throws on both read and write. Losing a stored
 * preference is a fine outcome; an uncaught exception during first paint is
 * not. Shared by ThemeContext and I18nProvider so the guard exists once.
 */

export function readStored(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* not fatal */
  }
}
